import Utils from '../common/Utils';
import { API_DOMAIN, GLOBAL_PATH, STORE, MYFEED } from '../common/Model';
import { communityHomeL10n } from '../common/L10n';

export default class Myfeed {
	constructor(_config) {
		this.config = _config;
		this.serviceEnv = _config.serviceEnv.toUpperCase() || 'LIVE';
		let _option = {
			type: 'api',
			service : this.config.service,
			menu : 'myfeed',
			locale : this.config.locale,
			country : this.config.country
		};

		let _communityApi;
		if (this.config.service==='lineage2mru' || this.config.service==='lineage2mnaeu') {
			_communityApi = API_DOMAIN.GLOBAL_COMMUNITY[this.serviceEnv];
		} else if (this.config.service ==='lineage2mnct') {
			_communityApi = API_DOMAIN.NCT_COMMUNITY[this.serviceEnv];
		} else if (this.config.service ==='lineage2mncj') {
			_communityApi = API_DOMAIN.NCJ_COMMUNITY[this.serviceEnv];
		} else {
			_communityApi = API_DOMAIN.COMMUNITY[this.serviceEnv];
		}
		this.myfeedUrl =  _communityApi + GLOBAL_PATH(_option);

		// l10n // window.communityHomel10n
		this.l10n = communityHomeL10n[this.config.lang];

		this.l10n.tagCategoryName = MYFEED.TAG.CATEGORY_NAME[this.config.service];
		this.l10n.myFeedInfo = MYFEED.MESSAGE_NODATA[this.config.service] || this.l10n.myFeedInfo;

		// this.l10n.myFeedBeforeLogin = window.communityHomel10n ? window.communityHomel10n.myFeedBeforeLogin : '로그인 후 나를 위한 맞춤 콘텐츠를 확인해보세요.' ;
		// this.l10n.login = window.communityHomel10n ? window.communityHomel10n.login : '로그인' ;
		// this.l10n.myFeedNoData = window.communityHomel10n ? window.communityHomel10n.myFeedNoData : '업데이트된 새 글이 없습니다.';
		// this.l10n.pageError = window.communityHomel10n ? window.communityHomel10n.myFeedNoData : '일시적으로 페이지를 불러올 수 없습니다. <br/> 잠시 후 다시 접속해주세요.';
		// console.log( '# myfeed.js this.l10n : ', MYFEED.MESSAGE_NODATA[this.config.service], this.l10n.myFeedInfo );

		this.container = document.querySelector('.home-myfeed');
		// console.log( '# myfeed.js > this.myfeedUrl : ', this.myfeedUrl);
	}

	init() {
		//console.log( '# myfeed.js > STORE.data.myfeed : ', STORE.data.myfeed, Utils.isEmptyObject(STORE.data.myfeed) );
		if (this.config.isLogin) {
			let wrapperTmpl = `
			<section class="myfeed-wrapper"><div class="home-loading"></div></section>`;
			if( Utils.isEmptyObject(STORE.data.myfeed)) {
				this.container.innerHTML = wrapperTmpl;
				this.get();
			}
		} else {
			let loginTmpl = `
			<div class="myfeed-message-wrap">
			<h2 class="myfeed-message">${this.l10n.myFeedBeforeLogin}</h2>
			<div class="myfeed-btn-wrap">
			<button type="button" class="myfeed-btn-login" onclick="javascript:GNBLogin();">${this.l10n.login}</button>
			</div>
			</div>`;
			this.container.innerHTML = loginTmpl;
		}
	}

	empty() {
		let emptyTmpl = `
			<div class="myfeed-message-wrap">
			  <h2 class="myfeed-message">${this.l10n.myFeedNoData}</h2>
			  <p class="myfeed-message-desc">${this.l10n.myFeedInfo}</p>
			</div>`;
		this.container.innerHTML = emptyTmpl;
	}

	get() {
		const _this = this;

		fetch(this.myfeedUrl, {
			dataType: "json",
			type: "GET",
			credentials: 'include',
			xhrFields: {withCredentials: true},
			headers: {
				'Content-Type': 'application/json', 'Accept': 'application/json'
			}
		}).then(function (response) { // The API call was successful!
			if (response.ok) {
				return response.json();
			} else {
				return Promise.reject(response);
			}
		}).then(function (data) { // This is the JSON from our response
			// console.log(data);
			if (document.querySelectorAll('.home-loading').length > 0 ) document.querySelector('.home-loading').remove(); // loading
			if (data.length <= 0) {
				STORE.data.myfeed = [{myFeedType: "NODATA"}];
				_this.empty();
			} else {
				STORE.data.myfeed = data;
				_this.render(data);
			}
		}).catch(function (err) { // There was an error
			console.warn('Something went wrong.', err);
			_this.container.innerHTML = `<div class="myfeed-message-wrap"><p class="myfeed-message-desc">${_this.l10n.pageError}</p></div>`;
			console.log('오류가 발생했습니다.');
		});

	}
	render(data) {
		// console.log('## [homeMyfeed.js] render() data : ', data);
		const wrapper = document.querySelector('.myfeed-wrapper');
		const tmpl = this.templ(data);
		if(data && data.length > 0) wrapper.innerHTML = tmpl;

	}

	templ(_d) {
		// console.log('## [homeMyfeed.js] templ() data : ', _d);
		return `
			<article class="myfeed-list">
			${_d.map( (item, index) => {
			return this.listTempl(item);
		}).join('')}
			</article>
		`;
	}

	listTempl(item) {
		const _type = item.myFeedType; // myFeedType : GROUP_BOARD : 혈맹 게시글 GROUP_NOTICE : 혈맹 공지글 TAG : 태그 새글 articleId
		const _isCountryPath = (this.config.service ==='lineage2mnct') ? `/lineage2m` : this.config.isGlobal ? `/${this.config.country}` : ``;
		const _category = (_type == MYFEED.TAG.TYPE) ? this.l10n.tagCategoryName : item.feed.category ? item.feed.category.categoryName : item.feed.rootBoard.board.boardName ? item.feed.rootBoard.board.boardName : '' ; // #클래스`;

		const _alias = (_type == MYFEED.TAG.TYPE) ? 'TAG' : item.feed.category ? item.feed.category.aliasName : ``; // guild_notice
		const _summary = (_type == MYFEED.TAG.TYPE) ? item.feed.content : item.feed.summary; //  item.feed.summary;
		const _url = (_type == MYFEED.TAG.TYPE) ? `${_isCountryPath}/board/${item.feed.clsf}/view?articleId=${item.feed.articleId}` : (!item.feed.url && ( _type == 'GROUP_BOARD' || _type == 'GROUP_NOTICE') ) ? `${_isCountryPath}/board/${item.feed.categoryBoard.boardAlias}/view?articleId=${item.feed.id}` : item.feed.url; // //  item.feed.url;

		const _thumb = (item.feed.thumbnailUrl) ? `<div class="myfeed-thumb"><img src="${item.feed.thumbnailUrl}"></div>` : ``;
		const _tag = (item.feed.userTags)? `<div class="myfeed-tag">${item.feed.userTags.map(it => `<a href="${_isCountryPath}/search/tag?query=${it}">${it}</a> `).join('')}</div>` : ``;

		return `
		<div class="myfeed-item ${item.feed.thumbnailUrl ? 'has-thumb' : ''}">
			<a class="myfeed-link" data-alias="${_alias}" href="${_url}">
				<div class="myfeed-category"><em>${_category}</em></div>
				${_thumb}
				<div class="myfeed-text">
					<div class="myfeed-title">${item.feed.title}</div>
					<div class="myfeed-summary">${_summary}</div>
				</div>
			</a>
			${_tag}
		</div>`;
	}

}